import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

function AlertMessage(props) {
  const [show] = useState(true);
  const { title, details } = props;
  if (show && title) {
    const detailMessage = details && details.length > 0 ? (
      <ul style={{ marginBottom: '0px', marginTop: '5px' }}>
        {details.map((detail) => (
          <li key={detail}>{detail}</li>
        ))}
      </ul>
    ) : '';

    return (
      <Alert variant="danger">
        <b>{title}</b>
        {detailMessage}
      </Alert>
    );
  }

  return null;
}

AlertMessage.propTypes = {
  title: PropTypes.string,
  details: PropTypes.arrayOf(PropTypes.string),
};

AlertMessage.defaultProps = {
  title: undefined,
  details: undefined,
};

export default AlertMessage;
